﻿﻿﻿<iframe id="analytics"
        style="height:90vh;display:block; width: -webkit-fill-available" 
        src="https://tke.sharepoint.com/teams/MERSYCDPtool/Shared%20Documents/Forms/AllItems.aspx"
        frameborder="0"
        allowFullScreen="true"></iframe>